module.exports = __webpack_public_path__ + "498aa659ec6a296f590d0bd547d2bf39.svg";